{
  "delete_schedule_version": {
    "title": "Excluir cronograma disciplinar",
    "message": "Excluir {{ scheduleVersionName }} também excluirá seus eventos. Deseja continuar?"
  },
  "show_schedule": "Mostrar programação",
  "delete_schedule": {
    "title": "Excluir cronograma da competição",
    "message": "Excluir {{ scheduleVersionName }} também excluirá seus cronogramas e eventos disciplinares. Deseja continuar?"
  },
  "toasts": {
    "scheduled_items_start_end_times_affected": "Os horários de início e término de alguns itens programados podem ter sido afetados"
  },
  "other": {
    "no_items_based_on_selection": {
      "Discipline": "Nenhum item a ser exibido com base na seleção da disciplina.",
      "Day": "Não há itens para mostrar com base na seleção do local."
    }
  },
  "errorMessages": {
    "scheduled_item_must_be_within_session": "O item agendado deve estar dentro dos horários de início e término da sessão",
    "must_end_after_start_time": "O evento deve terminar após o horário de início"
  },
  "session_form": {
    "medal_header": "Medalhas e cerimônias",
    "medal_ceremony": "Cerimônia de medalha",
    "includes_medal_ceremony": "Inclui cerimônia de entrega de medalhas"
  },
  "validation": {
    "startTimeValid": "O horário de início deve ter segundos, minutos e horas",
    "startTimeWithinParent": "A hora de início deve ser posterior à hora de início dos pais",
    "endTimeBeforeStartTime": "A hora de início deve ser antes da hora de término",
    "endTimeValid": "O horário de término deve ter segundos, minutos e horas",
    "endTimeWithinParent": "A hora de término deve ser antes da hora de término dos pais"
  },
  "activity": {
    "titleDeleteUnsaved": "Excluir linha não salva",
    "descriptionDeleteUnsaved": "Tem certeza de que deseja descartar essa nova linha?"
  },
  "divisions": "Divisões",
  "upload_event_blocks": {
    "title": "Carregar conteúdo do calendário",
    "calendar_level": "Nível do calendário",
    "delete_existing": "Excluir itens existentes",
    "delete_existing_confirmation_title": "Excluir itens existentes",
    "delete_existing_confirmation_description": "Você selecionou “Excluir itens existentes”. Isso excluirá todos os eventos do calendário na versão de programação selecionada e os substituirá pelos valores CSV fornecidos. Isso não pode ser desfeito. Você deseja continuar?",
    "csv_validation_errors_subtitle": "Erros de validação de CSV"
  },
  "exports": {
    "title": "Opções de exportação",
    "confirm": "Confirme",
    "cancel": "Cancelar",
    "message": "Escolha uma opção para exportar",
    "downloadTitle": "Baixar",
    "downloadDescription": "A exportação ODF será baixada para o seu computador",
    "publishedDescription": "A exportação ODF será publicada em {{ exportDestinationName }}",
    "notAvailable": "Não disponível"
  },
  "key": {
    "title": "Chave para programar cores de blocos"
  },
  "data_fields": {
    "event_unit_description": "Unidade de eventos",
    "event_name": "Evento",
    "competition_pahse": "Fase de competição",
    "gender": "Gênero",
    "medal_type": "Tipo de medalha",
    "ticketing_code": "Código de emissão de bilhetes",
    "ticketed": "Ingressado",
    "discipline": "A disciplina",
    "session_code": "Código da sessão",
    "session_style": "Estilo de sessão",
    "session_type": "Tipo de sessão",
    "venue_code": "Código do local",
    "Event": "Evento",
    "Phase": "Estágio",
    "Event unit": "Unidade de eventos",
    "Division": "Divisão",
    "Owner": "Proprietário",
    "multi_selector": {
      "all": {
        "Discipline": "Todas as disciplinas"
      },
      "none": {
        "Discipline": "Sem disciplinas"
      },
      "x_selected": {
        "Discipline": "{{ count }} disciplinas selecionadas"
      }
    },
    "view_by_day_label": {
      "Discipline": "Dia (Disciplina)"
    }
  },
  "scheduleDoesntExist": {
    "noPermission": "Um cronograma para este projeto não foi configurado. Você precisará pedir a um usuário com privilégios de administrador que faça isso por você.",
    "createTitle": "Configure o cronograma para este projeto",
    "createDescription": "Não foi definido um cronograma para este projeto. Configure a programação usando as configurações abaixo. Se você não tiver certeza de como configurar o agendamento, entre em contato com o suporte:"
  },
  "venueEdit": {
    "parentVenue": "Local para pais",
    "venueLocationType": "Tipo de localização do local",
    "topLevelVenueName": "Nível superior",
    "tryDeleteParent": "Remova as referências de ID principal desta linha antes de excluir",
    "tryEditParent": "{{ count }} os locais fazem referência a este como seu pai. Remova essas referências antes de continuar."
  },
  "sidebar": {
    "upload": "Carregar blocos de eventos",
    "deleteListItemMessage": "Tem certeza de que deseja excluir todos os itens da lista?",
    "deleteListItemTitle": "Excluir itens da lista"
  }
}